import { Routes } from "@angular/router";
import { GRID_SERVICES_ROUTE_DATA } from "@ppf/features/grid-services";
import { PRE_PROPOSAL_ROUTE_DATA } from "@ppf/features/pre-proposal";
import { PROGRAMS_ROUTE_DATA } from "@ppf/features/programs";
import { QUOTE_ROUTE_DATA } from "@ppf/features/quote/data";
import { metaResolver } from "@ppf/shared/resolvers";

export const routes: Routes = [
	{
		path: "",
		pathMatch: "full",
		redirectTo: "welcome",
	},
	// Unauthenticated Routes
	{
		path: "",
		loadComponent: () =>
			import("./view/view.component").then(c => c.ViewComponent),
		children: [
			{
				path: "welcome",
				loadComponent: () =>
					import("../features/welcome/welcome.component").then(
						c => c.WelcomeComponent,
					),
				title: "Welcome",
				data: {
					meta: {
						description:
							"Welcome to Qcells. Choose how we can help you!",
					},
				},
				resolve: { meta: metaResolver },
			},
			// Homeowner flow
			{
				path: PRE_PROPOSAL_ROUTE_DATA["base"].route,
				loadChildren: () =>
					import("../features/pre-proposal/pre-proposal.routes").then(
						r => r.preproposalRoutes,
					),
			},
			// Grid services flow
			{
				path: GRID_SERVICES_ROUTE_DATA["base"].route,
				loadChildren: () =>
					import(
						"../features/grid-services/grid-services.routes"
					).then(r => r.gridservicesRoutes),
			},
			// Quote / Solar calculator
			{
				path: QUOTE_ROUTE_DATA["base"].route,
				loadChildren: () =>
					import("../features/quote/quote.routes").then(
						r => r.quoteRoutes,
					),
			},
			// Grid Services Eligible Programs
			{
				path: PROGRAMS_ROUTE_DATA["base"].route,
				loadChildren: () =>
					import("../features/programs/programs.routes").then(
						r => r.programsRoutes,
					),
			},
			// Demo UI
			{
				path: "demo-ui",
				loadComponent: () =>
					import("../features/demo-ui/demo-ui.component").then(
						c => c.DemoUiComponent,
					),
			},
			{
				path: "**",
				loadComponent: () =>
					import("../features/not-found/not-found.component").then(
						c => c.NotFoundComponent,
					),
				title: "Page not found",
				data: {
					meta: {
						description:
							"Uh oh! Sorry, but the we cannot find the page you requested.",
					},
				},
				resolve: { meta: metaResolver },
			},
		],
	},
];
